import React from "react";
import { Field } from "formik";
import DimensionEditor from "./DimensionEditor";
import { parseFraction, formatFraction } from "./dimensions";

const DimensionField = ({ fieldName, label, min, max, defaultValue, onBlur, onChange }) => (
  <>
    <Field name={fieldName} id={fieldName}>
      {({ field: { value }, form: { setFieldValue, errors, touched } }) => (
        <>
          {touched[fieldName] && errors[fieldName] && <div className="errorMessage">{errors[fieldName]}</div>}
          <DimensionEditor
            label={label}
            value={value}
            update={text => {
              const parsed = parseFraction(text);
            const formatted = parsed ? formatFraction(parsed) : text;

            // Update Formik
            setFieldValue(fieldName, formatted);

            // Call parent's onChange if provided
            if (onChange) {
              onChange(formatted);
            }
            }}
            minValue={min}
            maxValue={max}
            defaultValue={defaultValue}
            isError={touched[fieldName] && errors[fieldName]}
            onBlur={onBlur}
          />
        </>
      )}
    </Field>
  </>
);

export default DimensionField;
